import { Navigate, useSearchParams } from 'react-router';

import { AVAILABLE_TOOLS } from '@/types/tools';

export const SplitScreenRedirect = () => {
  const [searchParams] = useSearchParams();
  const tool = searchParams.get('tool');
  const isValidTool = tool && AVAILABLE_TOOLS.some((t) => t.id === tool);

  const path = isValidTool ? `/tools/${tool}` : '/tools';

  const params = new URLSearchParams();
  const forwardedParams = [
    'versionId',
    'productId',
    'toolLinkId',
    'forceNewVersion',
    'projectId',
    'courseId',
    'moduleId',
    'lessonId',
    'prompt',
  ];
  for (const key of forwardedParams) {
    const value = searchParams.get(key);
    if (value) {
      params.set(key, value);
    }
  }

  const query = params.toString();
  const target = query ? `${path}?${query}` : path;

  return <Navigate to={target} replace />;
};
